<div class="col-md-12  mt-4">
    <div class="box box-widget widget-user shadow">
        <!-- Add the bg color to the header using any of the bg-* classes -->
        <div class="widget-user-header bg-aqua-active">

        </div>
        <div class="widget-user-image">
            <img class="img-circle" src="{{owner.avatar_url}}" alt="User Avatar">
        </div>

        <div class="box-footer">
            <h3 class="widget-user-username text-center"><b>{{owner.name}}</b></h3>
            <h5 class="text-center">{{owner.location}}</h5>
            <div class="row">
                <div class="col-sm-4 border-right">
                    <div class="description-block">
                        <h5 class="description-header">{{owner.public_repos}}</h5>
                        <span class="description-text">Repos</span>
                    </div>
                    <!-- /.description-block -->
                </div>
                <!-- /.col -->
                <div class="col-sm-4 border-right">
                    <div class="description-block">
                        <h5 class="description-header">{{owner.following}}</h5>
                        <span class="description-text">Following</span>
                    </div>
                    <!-- /.description-block -->
                </div>
                <!-- /.col -->
                <div class="col-sm-4">
                    <div class="description-block">
                        <h5 class="description-header">{{owner.followers}}</h5>
                        <span class="description-text">Followers</span>
                    </div>
                    <!-- /.description-block -->
                </div>
                <!-- /.col -->
            </div>
            <!-- /.row -->
        </div>
    </div>
</div>